



















































































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, Product, SurveyStatusType, SurveyStatusResult } from "@/interfaces";

import { AuthModule, SurveyModule } from "@/store";
import { getInitiativeAwareness, deleteInitiativeAwareness } from "@/services";

import { date } from "quasar";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class PromotionsInitiativeBrandAwareness extends Vue {
  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  elementsList: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";
  planningYear: number | null = null;

  mounted() {
    const planningYears = [...this.status.planning_years];
    const planningYear = planningYears.pop();

    if (planningYear) {
      this.planningYear = planningYear;
    }

    this.loadMatrix();
    this.setSurveyType(SurveyType.INITIATIVE_AWARENESS);
  }

  async loadMatrix() {
    try {
      this.loading = true;
      this.elementsList = this.filteredData = await getInitiativeAwareness(
        this.planningYear === null ? 2022 : this.planningYear,
      );
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.elementsList.filter(elements =>
        elements.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.elementsList;
    }
  }

  goToSurvey() {
    this.$router.push(`survey/${SurveyType.INITIATIVE_AWARENESS}`).catch(error => console.log(error));
  }

  openShowElements(elements: Product) {
    this.$router
      .push(`survey/${SurveyType.INITIATIVE_AWARENESS}/${elements.surveys[0].id}`)
      .catch(error => console.log(error));
  }

  getElementsDate(elements: Product) {
    if (elements.surveys.length > 0) {
      return date.formatDate(elements.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  onDeleteElement(element: Product) {
    this.$q
      .dialog({
        title: "Attenzione",
        message: `Sei sicuro di volere eliminare l'iniziativa <strong>${element.name}</strong>`,
        html: true,
        cancel: true,
      })
      .onOk(() => {
        this.deleteElementAction(element);
      });
  }

  async deleteElementAction(element: Product) {
    try {
      await deleteInitiativeAwareness(element.id);
      this.loadMatrix();
      this.searchText = "";
      notifySuccess("Iniziativa rimossa con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile eliminare l'iniziativa!");
    }
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "actions", align: "center" },
      { name: "delete", align: "center" },
    ];
  }
}
